module.exports = __webpack_public_path__ + "img/Camera_shutter.b0905589.png";